/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import GenericSkeleton from '../../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';

const useStyle = makeStyles({
    product: {
        margin: 0,
    },
    variants: {
        marginBottom: '30px',
    },
});

export const VariantLoader = () => {
    const classes = useStyle();
    return (
        <div className={classes.variants}>
            <div><GenericSkeleton height="20px" width="100%" /></div>
            <div><GenericSkeleton height="20px" width="100%" /></div>
            <div><GenericSkeleton height="20px" width="100%" /></div>
        </div>
    );
};

const Loader = () => {
    const classes = useStyle();
    return (
        <>
            <div><GenericSkeleton height="150px" width="100%" className={classes.product} /></div>
            <div><GenericSkeleton height="150px" width="100%" className={classes.product} /></div>
            <div><GenericSkeleton height="150px" width="100%" className={classes.product} /></div>
            <div><GenericSkeleton height="150px" width="100%" className={classes.product} /></div>
            <div><GenericSkeleton height="150px" width="100%" className={classes.product} /></div>
        </>
    );
};

export default Loader;
